/*    
<summary>
   This file is used to provide initial values or state to the Change Password Module observables.
   Developer:Aashish Singh, Created Date:29-August-2023
</summary>
*/

import { IChangePassword, IUpdateAgreementPassword, IUpdateCustomerEmail, IUpdateLoggedInUserPassword, IUpdatePassword } from "../../models/forms/IChangePassword"



export const initialState: IChangePassword = {
    NewPassword: '',
    ConfirmPassword:'',
    OldPassword: ''
}

export const initialStateUpdatePassword: IUpdatePassword = {
    UserId: -1,
    NewPassword: '',
    ConfirmPassword:'',
}

export const initialStateLoggedInUserPassword: IUpdateLoggedInUserPassword = {
    NewPassword: '',
    OldPassword: ''
}

export const initialStateUpdateEmail: IUpdateCustomerEmail = {
    CustomerId: -1,
    Email: '',
   
}

export const initialStateAgreementPassword: IUpdateAgreementPassword = {
    Id:0,
    StoreId: -1,
    Password: '',
    ConfirmPassword: "",
   
}